export function CusomizeText(data) {
    if(data === null || data === undefined) {
        return '';
    }
    if(data.length > 20) {
        var result = data.substring(0,20)+'...'; 
        return result
      }
    return data;
}